import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs-compat/Observable';
import { ServiceBase } from 'app/shared/infrastructure/serviceBase.component';
import { environment } from 'environments/environment';
@Injectable()
export class PatientPackageSearchService extends ServiceBase {

    constructor(private _http: HttpClient) {
        super();
    }

    getPatientPackageDetails = (filter: any): Observable<any> => {

        return this._http.post<any>(`${environment.queryModel}PatientPackage/PatientPackageDetails`, filter);
    }

    getPackagePlanUsage = (filter: any): Observable<any> => {

        return this._http.post<any>(`${environment.queryModel}PatientPackage/PackagePlanUsage`, filter);
    }
}